import React from 'react'

import apple from '@kolayyolla/common/images/apple-store.png'
import bgWave from '@kolayyolla/common/images/bgWave.svg'
import google from '@kolayyolla/common/images/google-store.png'
import phones from '@kolayyolla/common/images/phones.png'

import { Container, Grid, Stack, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#faefef',
    paddingTop: theme.spacing(2),
    backgroundImage: `url(${bgWave}), linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgb(250, 239, 239,1) 25%)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    overflow: 'hidden'
  },
  header: {
    fontWeight: 'bold',
    color: theme.palette.primary.dark
  },

  img: {
  },
  gridImg: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'center'
  },
  gridText: {
    marginTop: theme.spacing(6),
    textAlign: 'left',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
      alignItems: 'center'
    }
  },
  storeImg: {
    width: 140,
    height: 40
  }
}))

export default function DownloadAppBanner () {
  const classes = useStyles()

  return (
    <div className={classes.container} >
      <Container>
        <Grid container spacing={8} mt={0} mb={-10} justifyContent="center" >
          <Grid lg={6} xs={12} item className={classes.gridImg} order={{ lg: 1, xs: 2 }}>
            <img src={phones} className={classes.img} />
          </Grid>

          <Grid lg={6} xs={12} item className={classes.gridText} order={{ lg: 2, xs: 1 }}>
            <Typography variant="h4" gutterBottom component="div" className={classes.header}>
            Uygulamayı indir
            </Typography>
            <Typography variant="body1" gutterBottom component="div">
              Yemek sipariş vermek hiç bu kadar kolay olmamıştı. Her siparişinde kazanmak için sende hemen uygulamayı indir
            </Typography>

            <Stack direction="row" spacing={1} mt={5} mb={5} maxWidth={300}>
              <a href="https://apps.apple.com/tr/app/kolayyolla/id1586201233">
                <img src={apple} className={classes.storeImg} />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.kolayyolla.android.app">
                <img src={google} className={classes.storeImg} />
              </a>
            </Stack>
          </Grid>

        </Grid>

      </Container>

    </div>
  )
}
